import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import LoadingOverlay from 'components/UI/LoadingOverlay';
import StepperSidebar from 'components/UI/StepperSidebar';
import type { FC, ReactNode } from 'react';
import { NAVY, RADIUS_COIN, SHADOW, SURFACE_CONTAINER_LOW, SURFACE_CONTAINER_LOWEST, YELLOW } from 'styles/tokens';

interface WizardShellProps {
  title: string;
  subtitle?: string;
  steps: string[];
  activeStep: number;
  isLoading?: boolean;
  children: ReactNode;
}

const WizardShell: FC<WizardShellProps> = ({ title, subtitle, steps, activeStep, isLoading, children }) => {
  const progressPct = ((activeStep + 1) / steps.length) * 100;

  return (
    <>
      <LoadingOverlay visible={!!isLoading} />
      <Box sx={{ display: 'flex', height: '100%', fontFamily: 'Jost, sans-serif' }}>
        <StepperSidebar title={title} subtitle={subtitle} steps={steps} activeStep={activeStep} />

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            m: 2,
          }}
        >
          {/* Mobile header */}
          <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: NAVY, mb: 1 }}>
              {title}
              {subtitle ? ` ${subtitle}` : ''}
            </Typography>
            <Typography variant="caption" sx={{ color: NAVY, opacity: 0.4 }}>
              Paso {activeStep + 1} de {steps.length} — {steps[activeStep]}
            </Typography>
            <Box
              sx={{
                bgcolor: SURFACE_CONTAINER_LOW,
                borderRadius: 2,
                height: 3,
                mt: 1,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  width: `${progressPct}%`,
                  backgroundColor: YELLOW,
                  borderRadius: 2,
                  transition: 'width 0.4s ease',
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              bgcolor: SURFACE_CONTAINER_LOWEST,
              borderRadius: RADIUS_COIN,
              boxShadow: SHADOW,
              p: { xs: 2, md: 3 },
              overflow: 'auto',
            }}
          >
            <Fade in key={activeStep} timeout={300}>
              <Box>{children}</Box>
            </Fade>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default WizardShell;
